import { API_ROUTES_FOR_AXIOS } from 'src/constants/ApiRoutes';
import { axiosInstance } from 'src/constants/axiosInstance';
import { ApiResponse } from 'src/types/commonResponseTypes';
import { LanguageType } from 'src/types/organization';
import { handleError } from 'src/utils/commonErrorUtils';

export const getLanguages = async (): Promise<ApiResponse<LanguageType[]>> => {
  try {
    const apiUrl = API_ROUTES_FOR_AXIOS['getSupportedLanguages']();

    const { data } = await axiosInstance.get(apiUrl);

    return data;
  } catch (error) {
    return handleError(error);
  }
};
